import { createContext, useContext } from 'react';

export const AccountClosureContext = createContext({ mode: 'legacy', refresh: async () => 'legacy' });
export const useAccountClosure = () => useContext(AccountClosureContext);
